$(function() {

  $("#header-menu").on("click", (evt, )=>{
    $("#header-menu").toggleClass('active');
    $(".mobile-menu").toggleClass('active');
  });
  $("#search, #search-menu").on("click", (evt)=>{
    $(".search-panel").toggleClass('open');

    if ($(evt.target).closest('#search-menu').length) {
      $(".mobile-menu").removeClass('active');
      $("#header-menu").removeClass('active');
    }
    if ($(".search-panel").hasClass('open')) {
      $(".search-panel input").focus(); // Focus the input when the panel is open
    }
  });

  $(".clear-search").on("click", (evt) => {
    evt.preventDefault()
    $(".search-panel input").val(''); // Clear the input field
    $(".search-panel").removeClass('open'); // Close the panel
  });

  $(document).on("click", (evt) => {
    if (!$(evt.target).closest('.search-panel, #search, #search-menu').length) {
      $(".search-panel").removeClass('open'); // Close the panel

    }

    if (!$(evt.target).closest('.mobile-menu, #header-menu').length) {
      $(".mobile-menu").removeClass('active');
      $("#header-menu").removeClass('active');
    }
  });

});
